import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wkvuyha6r2: FaireBrandEntity = {
  token: "b_wkvuyha6r2",
  type: "brand",
  name: "Jessicurl",
  avatarUrl:
    "https://cdn.faire.com/fastly/b3e95bec1f3e4a139a8f70e37e021b1f48f960895447772b60559340da570fef.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0a53aa4376df43f411b5407f17ca8169587610c12c65fa0020eac636b20db2a5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b3e95bec1f3e4a139a8f70e37e021b1f48f960895447772b60559340da570fef.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0a53aa4376df43f411b5407f17ca8169587610c12c65fa0020eac636b20db2a5.jpeg",
  location: "Arcata, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "What is Jessicurl? Well, that’s not a cut and dry question to answer. On the surface, Jessicurl is a line of products for people with curly hair. It’s also a philosophy. One where you are not only allowed but ENCOURAGED to love your curly hair in its natural state, stop straightening it, and realize that You Have the Right To Remain Curly!  Of course, the high quality products make it that much easier and I’m eager to share my ingredients philosophy with you.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:40.181Z",
    importedBy: "entity-db-cli",
  },
};
